export const metaMixin = {
	data() {
		return {
			event_types: [],
			statusses: [],
		
		}
	},
	methods:{

		load_meta_data() {
			let self = this; // make sure we can access this inside of our promisses
			this.errormsg = '';

			axios
				.get("/api/events/meta", {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}


					if (json.status == "OK") {
						// get leave types, and sort by leave_order
						const event_types = json.data.event_types;
						const leave_order = ['annual leave', 'personal leave', 'unpaid leave', 'long service leave'];

						const order_leave_arr = [];
						leave_order.forEach(leave => {
							const arr = event_types.filter(e => { return e.desc.toLowerCase() === leave })
							order_leave_arr.push(arr[0])
						});

						const unorder_leave_arr = event_types.filter(type => { return !leave_order.includes(type.desc.toLowerCase())})
						self.event_types = [...order_leave_arr, ...unorder_leave_arr];

						
						self.statusses = json.data.statusses;
						self.statusses.sort(function(a,b) { return a.id > b.id });
						
					} else {
						self.errormsg = json.reason;
					}
				})
				.catch(function(e) {
					console.log(e);
					self.errormsg = e.message;
				});
		},
		eventtype_desc(id) {
			for (let i = 0; i < this.event_types.length; i++) {
				if (this.event_types[i].id == id) {
					return this.event_types[i].desc
				}
			}

			return "???"
		},

	}
}
